import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { buildDocFields } from './entryHelpers';

/** Document checkboxes row at the bottom of the EditEntryPanel. */
export default function EntryDocChecklist({ formData, onToggle }) {
  const docFields = buildDocFields(formData.other_vehicle_involved);
  return (
    <div className="space-y-3 pt-3 pb-4">
      <label className="text-gray-500 text-sm block">Documents</label>
      {docFields.map(({ label, field }) => (
        <div key={field} className="flex items-start space-x-2">
          <Checkbox
            id={`entry-doc-${field}`}
            checked={!!formData[field]}
            onCheckedChange={() => onToggle(field)}
            className="w-5 h-5 border-2 mt-0.5"
            data-testid={`edit-entry-doc-${field}`}
          />
          <Label htmlFor={`entry-doc-${field}`} className="text-sm text-gray-700 cursor-pointer leading-snug">
            {label}
          </Label>
        </div>
      ))}
    </div>
  );
}
